export default "__VITE_ASSET__Cjd7pN_q__"